import { SET_CLIENT_BOOKS } from "../actions/action-types.js";

export default function clientBooks(state = {}, {type, payload}) {
    switch (type) {
        case SET_CLIENT_BOOKS:
            return (state = payload)
        default:
            return state
    }
}